<template>
  <span>
    <v-row dense>
      <v-col v-if="!timeOnly">
        <v-menu

          ref="date-menu"
          v-model="menus.date"
          :close-on-content-click="false"
          :return-value.sync="values.date"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="values.date"
              :outlined="outlined"
              label="Date"
              prepend-inner-icon="mdi-calendar-outline"
              readonly
              v-bind="attrs"
              v-on="on"
            />

          </template>
          <v-date-picker
            v-model="values.date"
            no-title
            scrollable
          >
            <v-spacer />
            <v-btn
              text
              color="primary"
              @click="menus.date = false"
            >Cancel</v-btn>
            <v-btn
              text
              color="primary"
              @click="handleSave(values.date,'date-menu')"
            >OK</v-btn>
          </v-date-picker>
        </v-menu>
      </v-col>
      <v-col v-if="!dateOnly">
        <v-menu

          ref="time-menu"
          v-model="menus.time"
          :close-on-content-click="false"
          :nudge-right="40"
          :return-value.sync="values.time"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="values.time"
              :outlined="outlined"
              label="Time"
              prepend-inner-icon="mdi-clock-outline"
              readonly
              v-bind="attrs"
              v-on="on"
            />
          </template>
          <v-time-picker
            v-if="menus.time"
            v-model="values.time"
            full-width
            @click:minute="handleSave(values.time,'time-menu')"
          />
        </v-menu>
      </v-col>
      <!-- <v-col v-if="!dateOnly">
         <v-autocomplete
          v-model="values.timezone"
          outlined
          :items="locales"
          item-text="value"
          item-value="value"
          prepend-inner-icon="mdi-map-clock-outline"
          label="Timezone"
          @change="evaluate"
        />
      </v-col> -->
    </v-row>
    <div
      class="text-right"
      style="margin-top:-30px"
    >
      <v-btn
        text
        x-small
        @click="clear"
      >
        <v-icon
          x-small
          left
        >mdi-eraser</v-icon> clear</v-btn>
    </div>

  </span>
</template>

<script>
  import { LOCALES } from './constants'
  export default {
    name: 'DateTimePicker',
    props: {
      value: {
        type: String,
        default: '',
      },
      label: {
        type: String,
        default: null,
      },
      required: {
        type: Boolean,
        default: false,
      },
      outlined: {
        type: Boolean,
        default: false,
      },
      dateOnly: {
        type: Boolean,
        default: false,
      },
      timeOnly: {
        type: Boolean,
        default: false,
      },
      timezone: {
        type: Boolean,
        default: false,
      },
    },
    data () {
      return {
        locales: [],
        menus: {
          date: false,
          time: false,

        },
        values: {
          date: '',
          time: '',
          timezone: 'Europe/Paris',
        },
      }
    },
    computed: {
      computedValue () {
        return this.values.date + ' ' + this.values.time
      },
    },
    watch: {
      value (nv, ov) {
        if (nv) {
          const m = this.$moment(nv)
          this.values.date = m.format('YYYY-MM-DD')
          this.values.time = m.format('HH:mm')
        }
      },
    },
    mounted () {
      this.locales = this._.map(LOCALES, (v, key) => {
        return {
          text: v,
          value: key,
        }
      })
    },
    methods: {
      handleSave (v, ref) {
        if (ref === 'time-menu' && !this.values.date && !this.timeOnly) {
          const today = this.$moment().format('YYYY-MM-DD')
          this.values.date = today
          this.$refs['date-menu'].save(today)
        }
        if (ref === 'date-menu' && !this.values.time && !this.dateOnly) {
          const today = '00:00'
          this.values.time = today
          this.$refs['time-menu'].save(today)
        }

        this.$refs[ref].save(v)
        this.evaluate()
      },
      clear () {
        this.values = {
          date: '',
          time: '',
          timezone: 'Europe/Paris',
        }
        this.evaluate()
      },
      evaluate () {
        const date = this.values.date
        const time = this.values.time
        const tz = this.values.tz

        const m = this.$moment(date + ' ' + time)
        const format = this.dateOnly ? 'YYYY-MM-DD' : (this.timeOnly ? 'HH:mm' : 'YYYY-MM-DD HH:mm:ss')
        this.$emit('change', m.format(format))
        this.$emit('input', m.format(format))
        this.$emit('value', m.format(format))
      },
    },
  }
</script>

<style scoped>

</style>
